import { Link, Navigate } from "react-router-dom";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { useState, useEffect, useRef } from "react";
import { Form, Button, Row, Col, Alert } from 'react-bootstrap';
import Sidebar from "./Sidebar";
import "../App.css";
import { RootState } from "../Redux/store";
import { setAuth } from "../Redux/authSlice";
import { FaBars, FaCreditCard, FaSignOutAlt, FaUser, FaUserCircle } from "react-icons/fa";
import { toggleLanguage } from "../Redux/languageSlice";
import { translations } from "../utils/translations";


interface NavProps {
  toggleSidebar: () => void;
}

export const Nav: React.FC<NavProps> = ({ toggleSidebar }) => {
  const auth = useSelector((state: RootState) => state.auth.value);
  const language = useSelector((state: RootState) => state.language.language);
  const t = translations[language as keyof typeof translations];
  const dispatch = useDispatch();
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const logout = async () => {
    await axios.post('https://api.sominnovations.xyz/users/logout', {}, { withCredentials: true });
    dispatch(setAuth(false));
    deleteTokenCookie();
    window.location.href = "/";
  };

  const deleteTokenCookie = () => {
    document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  };

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
      setShowDropdown(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <header
        className="p-2 text-black"
        style={{ backgroundColor: "#ffff", height: "60px", boxShadow: "0px 0px 7px rgba(0, 0, 10, 0.2)" }}
        id="navbar"
      >
        <div className="container-fluid">
          <div className="d-flex flex-wrap align-items-center justify-content-between">
            <div className="poss d-flex align-items-center">
              {/* Sidebar Toggle Button for Mobile */}
              <button
                className="btn btn-link text-primary d-lg-none me-3 p-0"
                onClick={toggleSidebar}
                style={{ fontSize: '1.5rem' }}
              >
                <FaBars />
              </button>

              <Link to="/pos" style={{ textDecoration: "none" }} className="me-3 d-none d-lg-block">
                <FaCreditCard size={30} color="#5271ff" style={{ cursor: "pointer" }} />
              </Link>

              <button
                className="btn btn-outline-primary btn-sm me-3"
                onClick={() => dispatch(toggleLanguage())}
                style={{ borderRadius: '20px', fontWeight: 'bold' }}
              >
                {t.switchLanguage}
              </button>
            </div>
            {auth ? (
              <div
                className="user-icon-container"
                onClick={toggleDropdown}
                style={{ position: "relative" }}
                ref={dropdownRef}
              >
                <FaUserCircle size={30} color="#5271ff" style={{ cursor: "pointer" }} />
                {showDropdown && (
                  <div
                    className="dropdown-menu"
                    style={{
                      position: "absolute",
                      top: "40px",
                      right: "0",
                      backgroundColor: "white",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                      borderRadius: "8px",
                      padding: "10px",
                      minWidth: "150px",
                      zIndex: 1000,
                      display: "block"
                    }}
                  >
                    <Link
                      to="/Account"
                      className="dropdown-item"
                      style={{ color: "#5271ff", display: "flex", alignItems: "center", textDecoration: "none", marginBottom: "8px" }}
                    >
                      <FaUser style={{ marginRight: "8px" }} /> My Profile
                    </Link>
                    <button
                      onClick={logout}
                      className="dropdown-item"
                      style={{ color: "red", display: "flex", alignItems: "center", border: "none", background: "none", cursor: "pointer", padding: "0", textAlign: "left" }}
                    >
                      <FaSignOutAlt style={{ marginRight: "8px" }} /> Logout
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <div className="text-end" style={{ backgroundColor: "rgba(0, 0, 0, 0.2)", color: "white" }}>
                <Link to="/" className="btn btn me-2">
                  Login
                </Link>
              </div>
            )}
          </div>
        </div>
      </header>
    </>
  );
};

